import React from 'react';
import PropTypes from 'prop-types';

import { isEmailValid } from '../../../shared/js/util/validationUtils';

import classNames from 'classnames';

class ValidationEmails extends React.PureComponent {
    static contextTypes = {
        handleEmailsOnChange: PropTypes.func,
        isDisabled: PropTypes.bool,
        isHeightForTextarea: PropTypes.bool,
        isModifyHeightInput: PropTypes.bool,
        listEmails: PropTypes.array
    };

    static defaultProps = {
        handleEmailsOnChange: () => {},
        isDisabled: true,
        isHeightForTextarea: false,
        isModifyHeightInput: false,
        listEmails: []
    };

    tagInput = {};

    constructor(props) {
        super(props);

        this.state = {
            emails: this.props.listEmails || [],
            inputValue: '',
            focusingToInput: false,
            ref: {}
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.listEmails !== prevProps.listEmails) {
            this.setState({ emails: this.props.listEmails });
        }
    }

    validateCurrentEmails = () => {
        const { emails: emailsState } = this.state;

        return this.validateEmails(emailsState);
    };

    validateTypingEmails = () => {
        const { inputValue } = this.state;

        return this.validateEmails(inputValue.split(','));
    };

    validateEmails = (emailsInput) => {
        const emails = emailsInput.filter((email) => !!email) || [];

        const validEmails = emails.filter((email) => isEmailValid(email));
        const invalidEmails = emails.filter((email) => !isEmailValid(email));

        return { validEmails, invalidEmails, emails };
    };

    onFocusInput = () => this.setState({ focusingToInput: true });

    onBlurInput = () => {
        this.handlePushInputEmailToState();
        this.setState({ focusingToInput: false });
    }

    handlePushInputEmailToState = () => {
        let { inputValue, emails } = this.state;
        if (!inputValue?.trim()) {
            return;
        }

        inputValue = inputValue.toLowerCase();
        let emailsUpdate = [...emails];

        if (inputValue.includes(',')) {
            const emailSplited = inputValue.split(',').filter((value) => !!value.trim());

            emailsUpdate = emailsUpdate.concat(emailSplited);
        } else {
            emailsUpdate.push(inputValue);
        }

        this.handleEmailsOnChange(emailsUpdate);
        this.setState({ emails: emailsUpdate, inputValue: '' });
    };

    handlePasteEmailsWhichLastEmailNotComma = (inputValue) => {
        let { emails } = this.state;
        if (!inputValue?.trim()) {
            return;
        }

        inputValue = inputValue.toLowerCase();
        let emailsUpdate = [...emails];
        let emailSplited = [];

        if (inputValue.includes(',')) {
            emailSplited = inputValue.split(',').filter((value) => !!value.trim());
            emailsUpdate = emailsUpdate.concat(emailSplited.slice(0, -1));
        } else {
            emailsUpdate.push(inputValue);
        }

        this.handleEmailsOnChange(emailsUpdate);
        this.setState({ emails: emailsUpdate, inputValue: emailSplited[emailSplited.length - 1] });
    };

    handleKeyDown = (event) => {
        const keyCode = event.keyCode;
        if (keyCode === 32 || keyCode === 13 || keyCode === 188) {
            this.handlePushInputEmailToState();
        } else if (keyCode === 8) {
            this.handleRemoveValueFromInput();
        }
    };

    handleRemoveValueFromInput = () => {
        const { inputValue, emails } = this.state;

        if (!inputValue.trim().length) {
            const emailsFromState = [...emails];
            emailsFromState.splice(-1);

            this.handleEmailsOnChange(emailsFromState);
            this.setState({ emails: emailsFromState });
        }
    };

    handleOnChangeInput = (event) => this.setState({ inputValue: event?.target?.value });

    handleRemoveEmail = (index) => {
        const { emails } = this.state;
        const newEmails = emails.filter((v, i) => index !== i);

        this.handleEmailsOnChange(newEmails);
        this.setState({ emails: newEmails });
    };

    handleEmailsOnChange = (emails) => {
        const isInvalid = emails.some((email) => !isEmailValid(email));
        this.props.handleEmailsOnChange(emails, isInvalid);
    }

    renderErrorMessage = () => {
        const { invalidEmails } = this.validateCurrentEmails();

        if (invalidEmails.length) {
            return (
                <div>
                    <small className="post-template-add-emails__error-messages">
                        Please enter a valid email address.
                    </small>
                </div>
            );
        }
        return;
    };

    renderEmailInput = () => {

        const { isHeightForTextarea, isDisabled, isModifyHeightInput } = this.props;
        const { inputValue, emails, focusingToInput } = this.state;

        let inputProps = {
            placeholder: emails.length ? '' : 'contact@coxautoinc.com, contact@example.com'
        };

        if (inputValue.includes(',')) {
            if (inputValue.slice(-1) === ',') {
                this.handlePushInputEmailToState();
            } else {
                this.handlePasteEmailsWhichLastEmailNotComma(inputValue);
            }
        };

        return (
            <div
                className={classNames(
                    'post-template-add-emails__emails-input',
                    { 'focus': focusingToInput },
                    { 'emails-input__height': isHeightForTextarea },
                    { 'disabled': isDisabled }
                )}
            >
                <ul className={classNames('post-template-add-emails__emails-input_tags', {'modify-height-input': isModifyHeightInput })}>
                    {!!emails && emails.map((email, index) => {
                        const className = isEmailValid(email) ? '' : 'invalid';
                        return (
                            <li key={index} className={className}>
                                <button
                                    type="button"
                                    disabled={isDisabled}
                                    onClick={() => {
                                        this.handleRemoveEmail(index);
                                    }}
                                >
                                    ×
                                </button>
                                {email}
                            </li>
                        );
                    })}
                    <li className="post-template-add-emails__emails-input_input">
                        <input
                            {...inputProps}
                            type="text"
                            className={classNames({ 'disabled': isDisabled })}
                            disabled={isDisabled}
                            onChange={this.handleOnChangeInput}
                            onFocus={this.onFocusInput}
                            onBlur={this.onBlurInput}
                            onKeyDown={this.handleKeyDown}
                            value={inputValue.trim()}
                            ref={(c) => {
                                this.tagInput = c;
                            }}
                        />
                    </li>
                </ul>
            </div>
        );
    };

    render() {
        return (
            <div className="post-template-add-emails">
                {this.renderEmailInput()}
                {this.renderErrorMessage()}
            </div>
        );
    }
}

export default ValidationEmails;
